import * as React from "react";
import { greenOnline } from "../colors";

export const SensorIcon = () => (
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 2616.05 1665.649" enable-background="new 0 0 2616.05 1665.649" xmlSpace="preserve">

			<path d="M2171.682,1542.893c391.536-391.533,391.536-1028.607,0-1420.142c-56.957-56.957,29.192-143.22,86.207-86.204
				c440.201,440.213,440.16,1152.39,0,1592.55C2200.944,1686.042,2114.646,1599.929,2171.682,1542.893z"/>

			<path d="M1983.389,1354.6c287.709-287.708,287.709-755.847,0-1043.556c-56.947-56.947,29.172-143.229,86.207-86.204
				c336.265,336.265,336.314,879.647,0,1215.967C2012.637,1497.752,1926.361,1411.628,1983.389,1354.6z"/>

			<path d="M1795.098,1166.309c183.884-183.887,183.884-483.088,0-666.971c-56.957-56.957,29.189-143.22,86.204-86.204
				c232.121,232.124,232.148,607.223,0,839.379C1824.353,1309.463,1738.068,1223.333,1795.098,1166.309z"/>

			<path d="M1606.805,978.013c80.058-80.058,80.058-210.324,0-290.382c-56.957-56.957,29.189-143.22,86.204-86.204
				c127.592,127.592,127.592,335.198,0,462.79C1636.052,1121.174,1549.789,1035.029,1606.805,978.013z"/>

			<path d="M358.163,1629.097c-440.141-440.129-440.227-1152.324,0-1592.55c56.957-56.957,143.22,29.189,86.204,86.204
				c-391.535,391.535-391.535,1028.609,0,1420.142C501.314,1599.839,415.195,1686.129,358.163,1629.097z"/>

			<path d="M546.456,1440.807c-336.268-336.274-336.317-879.65,0-1215.967c56.957-56.957,143.22,29.189,86.204,86.204
				c-287.708,287.709-287.708,755.848,0,1043.556C689.612,1411.551,603.482,1497.825,546.456,1440.807z"/>

			<path d="M734.749,1252.514c-232.118-232.124-232.154-607.226,0-839.379c56.951-56.958,143.219,29.189,86.204,86.204
				c-184.476,184.473-184.502,482.466,0,666.968C877.909,1223.262,791.765,1309.53,734.749,1252.514z"/>

			<path d="M923.042,1064.218c-214.136-214.136-13.838-562.833,86.204-462.79c23.805,23.805,23.805,62.399,0,86.204
				c-80.058,80.058-80.058,210.324,0,290.382C1066.194,1034.96,980.072,1121.247,923.042,1064.218z"/>

	<circle cx="1310.69" cy="832.812" r="132.267"/>

</svg>);


export const BellIconSmall = () => (<svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M18 8C18 6.4087 17.3679 4.88258 16.2426 3.75736C15.1174 2.63214 13.5913 2 12 2C10.4087 2 8.88258 2.63214 7.75736 3.75736C6.63214 4.88258 6 6.4087 6 8C6 15 3 17 3 17H21C21 17 18 15 18 8Z" stroke="#324054" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M13.7295 21C13.5537 21.3031 13.3014 21.5547 12.9978 21.7295C12.6941 21.9044 12.3499 21.9965 11.9995 21.9965C11.6492 21.9965 11.3049 21.9044 11.0013 21.7295C10.6977 21.5547 10.4453 21.3031 10.2695 21" stroke="#324054" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
);


export const ArrowBackIcon = () => {
	return (
		<svg width="24" height="24" viewBox="0 0 24 24" fill="none">
			<path
				d="M15 18L9 12L15 6"
				stroke="#000"
				strokeWidth="2.4"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	)
}

export const DotIcon = ({color}) => (
  <svg
    width="3mm"
    height="3mm"
    viewBox="0 0 2 2"
  >
    <circle cx="1" cy="1" r="1" fill={color} />
  </svg>
);

export const DoorIcon = ({ color = "#000000ff", size = 20 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="1"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    {/* Door frame */}
    <rect x="4" y="2" width="16" height="20" rx="1" />

    {/* Door knob */}
    <circle cx="15" cy="12" r="1" fill={color} />
  </svg>
);

export const AssignUserIcon = ({ color = "#000000ff", size = 20 }) => (
	<svg width="24" height="24"
  viewBox="0 0 24 24" fill="none"
  stroke={color}
  strokeWidth="1.8"
  strokeLinecap="round"
  strokeLinejoin="round">
  <circle cx="9" cy="8" r="3"/>
  <path d="M3 20c0-4 2.7-6 6-6"/>
  <path d="M16 11l2 2 4-4"/>
</svg>

)
export const AddUserIcon = ({ color = "#000000ff", size = 20 }) => (
		<svg width="24" height="24"
  viewBox="0 0 24 24" fill="none"
  stroke={color}
  strokeWidth="1.8"
  strokeLinecap="round"
  strokeLinejoin="round">
  <circle cx="9" cy="8" r="3"/>
  <path d="M3 20c0-4 2.7-6
            6-6h3"/>
  <path d="M18 14v6M15 17h6"/>
</svg>

)

export const AddIcon = ({ color = "#000000ff", size = 20 }) => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="12" y1="5" x2="12" y2="19"></line>
    <line x1="5" y1="12" x2="19" y2="12"></line>
  </svg> 

)